import { useState } from 'react';
import { Form } from 'reactstrap';
import { Search, ChevronDown, ChevronUp } from 'react-feather';
import ModalLoader from '../../../../layouts/modals/ModalLoader';
import ListadoSolicitudes from '../ListadoSolicitudes';
import useFiltroSolicitudes from './hooks/useFiltroSolicitudes';
import FiltrosFila1 from './FiltrosFila1';
import FiltrosFila2 from './FiltrosFila2';
import FiltrosFila3 from './FiltrosFila3';
import FormActions from './FormActions';

const FiltroSolicitudes = () => {
  const [showFilters, setShowFilters] = useState(true);
  const {
    dataApi,
    name,
    lastname,
    dni,
    email,
    idRequest,
    state,
    center,
    bd,
    course,
    headquarterList,
    coursesList,
    centersList,
    statesList,
    isFormSubmittable,
    isTableNotLoading,
    isProceedingLoading,
    deudores,
    userOU,
    searchMatState,
    handleNameOnChange,
    handleLastNameOnChange,
    handleDNIOnChange,
    handleIDOnChange,
    handleEmailOnChange,
    handleHeadquarter,
    handleCourses,
    handleState,
    handleCenters,
    handleDeudor,
    handleReset,
    handleOnSubmit,
    downloadExcel,
    loadMore,
    isLoadingMore,
    hasMore,
  } = useFiltroSolicitudes();

  return (
    <>
      {isProceedingLoading ? <ModalLoader header="Generando documento" /> : null}
      <Form onSubmit={handleOnSubmit}>
        <div style={{
          backgroundColor: '#fff', borderRadius: '12px',
          border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
          overflow: 'visible',
        }}>
          {/* Toolbar */}
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '12px 16px',
            borderBottom: showFilters ? '1px solid #f3f4f6' : 'none',
          }}>
            <button
              type="button"
              onClick={() => setShowFilters(!showFilters)}
              style={{
                display: 'flex', alignItems: 'center', gap: '6px',
                background: 'none', border: 'none', cursor: 'pointer',
                fontSize: '0.8rem', fontWeight: 600, color: '#374151',
                padding: '4px 8px', borderRadius: '6px',
              }}
            >
              <Search size={15} style={{ color: '#9ca3af' }} />
              Filtros
              {showFilters
                ? <ChevronUp size={14} style={{ color: '#9ca3af' }} />
                : <ChevronDown size={14} style={{ color: '#9ca3af' }} />}
            </button>
            <div style={{ display: 'flex', gap: '8px' }}>
              <FormActions
                isFormSubmittable={isFormSubmittable}
                isTableNotLoading={isTableNotLoading}
                dataApi={dataApi}
                handleReset={handleReset}
                downloadExcel={downloadExcel}
              />
            </div>
          </div>

          {/* Filtros colapsables */}
          {showFilters && (
            <div style={{
              padding: '16px',
              opacity: !isTableNotLoading ? 0.5 : 1,
              pointerEvents: !isTableNotLoading ? 'none' : 'auto',
              transition: 'opacity 0.2s',
            }}>
              <FiltrosFila1
                searchMatState={searchMatState}
                isTableNotLoading={isTableNotLoading}
                name={name}
                lastname={lastname}
                dni={dni}
                email={email}
                idRequest={idRequest}
                handleNameOnChange={handleNameOnChange}
                handleLastNameOnChange={handleLastNameOnChange}
                handleDNIOnChange={handleDNIOnChange}
                handleEmailOnChange={handleEmailOnChange}
                handleIDOnChange={handleIDOnChange}
              />
              <FiltrosFila2
                isTableNotLoading={isTableNotLoading}
                bd={bd}
                headquarterList={headquarterList}
                course={course}
                coursesList={coursesList}
                state={state}
                statesList={statesList}
                center={center}
                centersList={centersList}
                userOU={userOU}
                handleHeadquarter={handleHeadquarter}
                handleCourses={handleCourses}
                handleState={handleState}
                handleCenters={handleCenters}
              />
              <FiltrosFila3 deudores={deudores} handleDeudor={handleDeudor} />
            </div>
          )}
        </div>
      </Form>
      {dataApi !== '' ? (
        <ListadoSolicitudes
          dataApi={dataApi}
          onLoadMore={loadMore}
          isLoadingMore={isLoadingMore}
          hasMore={hasMore}
        />
      ) : null}
    </>
  );
};

export default FiltroSolicitudes;
